import React from 'react';
import { ChefHat, Trash2, Mail, Clock, Shield, AlertCircle } from 'lucide-react';

const DeleteAccount = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-orange-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md shadow-sm">
        <div className="container mx-auto px-4 py-4 flex items-center space-x-3">
          <a href="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_cf5884b0-6cc6-42b4-b863-35f98b8ffb31/artifacts/rn9a0bc7_WhatsApp%20Image%202026-02-11%20at%2017.09.43.jpeg"
              alt="Tiffsy Logo"
              className="h-12 w-12 object-contain rounded-lg"
            />
            <span className="text-2xl font-bold text-orange-600">Tiffsy</span>
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-16 max-w-2xl">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
            <Trash2 className="w-8 h-8 text-red-500" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Delete Your Tiffsy Account</h1>
          <p className="text-gray-500">We're sorry to see you go. Please read the information below before submitting your request.</p>
        </div>

        {/* How to Request */}
        <div className="bg-white rounded-2xl shadow-sm border border-orange-100 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <Mail className="w-5 h-5 text-orange-500" />
            How to Request Deletion
          </h2>
          <p className="text-gray-600 mb-4">Send an email to us with your registered phone number or email address:</p>
          <a
            href="mailto:support@tiffsy.com?subject=Account Deletion Request"
            className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-semibold px-6 py-3 rounded-xl transition-colors duration-200"
          >
            Email: support@tiffsy.com
          </a>
          <p className="text-gray-500 text-sm mt-4">
            Subject: <span className="font-medium text-gray-700">Account Deletion Request</span><br />
            Include your registered phone number or email in the message.
          </p>
        </div>

        {/* What gets deleted */}
        <div className="bg-white rounded-2xl shadow-sm border border-orange-100 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <Shield className="w-5 h-5 text-orange-500" />
            What Gets Deleted
          </h2>
          <ul className="space-y-2 text-gray-600">
            {[
              'Your profile (name, email, phone number)',
              'Saved delivery addresses',
              'Subscription details and preferences',
              'Order history and meal preferences',
            ].map((item) => (
              <li key={item} className="flex items-start gap-2">
                <span className="mt-1 w-2 h-2 rounded-full bg-red-400 flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Retention */}
        <div className="bg-white rounded-2xl shadow-sm border border-orange-100 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
            <Clock className="w-5 h-5 text-orange-500" />
            Data Retention Policy
          </h2>
          <p className="text-gray-600">
            Transaction and payment records may be retained for up to <span className="font-semibold text-gray-800">90 days</span> after
            your deletion request for legal and financial compliance purposes. After this period, all personal data is permanently deleted
            from our systems.
          </p>
        </div>

        {/* Processing time */}
        <div className="bg-orange-50 border border-orange-200 rounded-2xl p-5 flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
          <p className="text-gray-700 text-sm">
            Deletion requests are processed within <span className="font-semibold">7 business days</span>. You will receive a confirmation
            email once your account has been deleted. Active subscriptions should be cancelled before requesting deletion.
          </p>
        </div>
      </main>

      {/* Footer */}
      <footer className="text-center py-8 text-gray-400 text-sm">
        © {new Date().getFullYear()} Tiffsy. All rights reserved.
      </footer>
    </div>
  );
};

export default DeleteAccount;
